import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {   
    
    pageTitle: string ;
    errorMessage: string = '';
    isRedirectionRequired: boolean = false; 
    code: string = '';
    constructor(
        private _route: ActivatedRoute,
        private _router: Router) { 
        
} 

    ngOnInit(): void {
        let that = this;
        this._route.queryParams.subscribe((params: Params) => {           
            that.code = params['code'];
        });

        if (this.code != undefined && this.code.trim() == "access_denied") {
            this.errorMessage = "You do not have access for this site. <br><br>Please contact dahelpdesk@sacda.org for getting access to this site.";
            // this.isRedirectionRequired = false;
        }
        else if (this.code != undefined && this.code.trim() == "invalid_grant") {
            this.errorMessage = "The provided authorization code or refresh token is expired. <b>Send a new interactive authorization request for this user and resource.";
            // this.isRedirectionRequired = false;
        }
        else {
            this.errorMessage = "We try hard to deliver the very best application we can, though once in a while a problem can occur. <br><br>Rest assured that we have recorded this error and will do our best to correct it soon.";
            // this.isRedirectionRequired = true;
        }

        }

    goTOLanding()
    {
        this._router.navigate(['/app-home']);
    }

    rediredtUrl(url) {
        window.location.href = url;
    }
}
